import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const OurStory = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Our Story"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Our Story" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section class="space-ptb">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12">
            <div class="section-title mb-4 pr-lg-5 px-4 px-lg-2">
              <h2 class="title"><span class="text-primary">Our Story</span></h2>
               <div className="curved-line mx-auto mt-3"></div>
            </div>            
          </div>          
        </div>
      </div>
    </section>
    </>
  )
}

export default OurStory
